
export const ADMIN_LOGIN = 'ADMIN/LOGIN'
export const ADMIN_SET = 'ADMIN/SET'
export const ADMIN_LOGOUT = 'ADMIN/LOGOUT'